import BaseComponent from './_BaseComponent'

export default class Filter extends BaseComponent {

    constructor($el, namespace) {
        super('Filter', $el, namespace)
        this.initAutoResize()
    }

    initAutoResize() {
        document.querySelectorAll('select.auto-resize').forEach((select) => {
            this.resizeSelect(select)
            select.addEventListener('change', () => this.resizeSelect(select))
        })
    }

    resizeSelect(select) {
        this.selectEl = select
        const optionText = select.options[select.selectedIndex].text

        // Create hidden span to measure text width
        const span = document.createElement('span')
        span.style.visibility = 'hidden'
        span.style.position = 'absolute'
        span.style.whiteSpace = 'nowrap'
        span.style.font = window.getComputedStyle(select).font
        span.textContent = optionText

        document.body.appendChild(span)
        select.style.width = `${span.offsetWidth + 40}px` // + 40 for arrow & padding
        document.body.removeChild(span)
    }

}
